import cn from 'classnames';
import React, { RefObject, useMemo } from 'react';
import cms from 'utils/cms';
import { useClientSelector } from 'client/reducers';
import { selectCmsItems } from 'client/reducers/story/selectors';
import type { BBCommonProps, BBEditableModeProps } from 'types/story';
import { ScriptRenderer } from 'client/components/common/ScriptRenderer/ScriptRenderer';
import withCardTransitionContext from 'client/components/common/BuildingBlocks/BuildingBlockEnhancer';
import css from './AIComponent.scss';

type Props = BBCommonProps;

const AIComponent: React.FC<Props> = props => {
	const { uiConfig, stateAttrs, eventListeners, containerRef, isEditableMode, editableModeProps } = props;
	const cmsItems = useClientSelector(selectCmsItems);

	const embedCode = useMemo(() => {
		const value = uiConfig.componentProps?.other?.embedCode ?? '';
		return cms.resolveCmsReferenceValue(value, cmsItems);
	}, [uiConfig.componentProps?.other?.embedCode, cmsItems]);

	const renderContent = (additionalProps: Partial<BBEditableModeProps['nodeProps']> = {}) => {
		const { nodeProps } = uiConfig;
		const className = cn(css.aiComponent, nodeProps.className, additionalProps.className, {
			[css.empty]: !embedCode,
		});
		const isHidden = uiConfig.componentProps.styles?.display === 'none';

		return (
			<div
				{...nodeProps}
				{...stateAttrs}
				{...eventListeners}
				{...additionalProps}
				className={className}
				ref={containerRef as RefObject<HTMLDivElement>}
			>
				{isHidden ? null : <ScriptRenderer value={embedCode} />}
			</div>
		);
	};

	if (isEditableMode) {
		const editableProps = { ...editableModeProps?.nodeProps };
		return renderContent(editableProps);
	}

	return renderContent();
};

export default withCardTransitionContext(AIComponent);
